export default __webpack_public_path__ + "fe2d5c257f663a10b2b6d3a4e52b9d2d.png";